export const mapOptions = (data) => {
    let options = []
    options = data.map(d => {
        return {
            value: d.id,
            text: d.name
        }
    })
    return options
}


// WEBPACK FOOTER //
// ./src/lib/shareFunctions.js